import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {Component} from "react";
import * as React from "react";
import {Card, CardHeader} from "reactstrap";
import DummyActionsRow from "./DummyActionsRow";
import './TablePanel.scss';

/**
 * Komponenta pro zobrazení karty jako tabulky.
 */
class TablePanel extends Component {

    static propTypes = {
        header: PropTypes.node, // záhlaví tabulky (typicky názvy sloupců)
        children: PropTypes.node, // jednotlivé položky tabulky,
        bordered: PropTypes.bool, // zda mají mít položky tabulky okraje
    };

    render() {
        const {header, children, bordered} = this.props;
        return <Card className={"table-panel"}>
            {header && <CardHeader>
                <DummyActionsRow>
                    {header}
                </DummyActionsRow>
            </CardHeader>}
            <div className={`items-list${bordered ? " bordered" : ""}`}>
                {children}
            </div>
        </Card>
    }
}

export default connect()(TablePanel);
